import { isStandalonePaymentEntry } from './utils';

export const H5_STANDALONE_POPUP_ACTIVE_KEY = 'h5StandalonePopupActive';

declare global {
  interface Window {
    /** Tab gốc sau khi đã mở popup thanh toán — không init modal ở tab này. */
    __JOYGAMES_STANDALONE_HANDOFF?: boolean;
  }
}

/**
 * Tab mở trực tiếp URL không thể window.close(). Mở popup (do script tạo) để sau thanh toán đóng được.
 * @returns true = chạy thanh toán trên tab/cửa sổ hiện tại; false = tab gốc, chỉ hiện handoff
 */
export function ensureStandalonePaymentPopup(): boolean {
  if (typeof window === 'undefined') return true;
  if (!isStandalonePaymentEntry()) return true;

  // Đã là popup (opener tồn tại) hoặc đã đánh dấu phiên popup
  if (window.opener && window.opener !== window) return true;
  if (sessionStorage.getItem(H5_STANDALONE_POPUP_ACTIVE_KEY) === '1') return true;

  sessionStorage.setItem(H5_STANDALONE_POPUP_ACTIVE_KEY, '1');
  const popup = window.open(
    window.location.href,
    'joygame_h5_payment',
    'noopener,noreferrer,width=440,height=760,scrollbars=yes,resizable=yes'
  );

  if (!popup) {
    sessionStorage.removeItem(H5_STANDALONE_POPUP_ACTIVE_KEY);
    return true;
  }

  try {
    popup.focus();
  } catch {
    /* ignore */
  }

  window.__JOYGAMES_STANDALONE_HANDOFF = true;
  return false;
}

export function clearStandalonePopupSession(): void {
  sessionStorage.removeItem(H5_STANDALONE_POPUP_ACTIVE_KEY);
}
